import { IEnvironment } from "../../interfaces";

export const switchDisabilityState = (
  prevDisabilityState: Record<string, boolean>,
  nonDisableEnv: string
) => {
  const newDisabilityState = Object.keys(prevDisabilityState).reduce(
    (prev, curr) => {
      if (curr === nonDisableEnv) {
        return { ...prev, [curr]: false };
      }

      return { ...prev, [curr]: true };
    },
    {}
  );

  return newDisabilityState;
};

export const switchUpdatingState = (
  prevUpdatingState: Record<string, boolean>,
  updatingEnv: string
) => {
  return { ...prevUpdatingState, [updatingEnv]: true };
};

export const getEnvsDefaultKeyBooleanState = (envs: IEnvironment[]) =>
  envs.reduce((prev, curr) => {
    return { ...prev, [curr.name]: false };
  }, {});
